// extracted by mini-css-extract-plugin
module.exports = {"borderedTextBadge":"_3GRo0W"};